import { useEffect, useState } from 'react';

import Badge from 'components/Badge';

import { useConversation } from 'hooks/conversation';
import { useView } from 'hooks/view';

import { MAX_UNREAD_MESSAGE_COUNT } from './constants';
import { VARIANTS } from 'components/Badge/constants';

const NotificationBadge = () => {
  const { conversationState } = useConversation();
  const { viewState } = useView();
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  useEffect(() => {
    if (viewState.isPanelOpen) {
      setUnreadMessageCount(0);

      // Need  delay so latest messages can render their animations.
      // Otherwise the Twilio `lastReadMessageIndex` will be updated too quickly.
      const timeout = setTimeout(() => {
        conversationState.twilio?.conversation.setAllMessagesRead();
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }

    conversationState.twilio?.conversation
      .getUnreadMessagesCount()
      .then((result) => setUnreadMessageCount(result ?? 0));
  }, [conversationState]);

  useEffect(() => {
    conversationState.twilio?.conversation
      .getUnreadMessagesCount()
      .then((unreadCount) => setUnreadMessageCount(unreadCount ?? 0));
  }, []);
  const showDisconnectedBadge = !viewState.isPanelOpen && conversationState.isInactivityTimeout;

  const formattedUnreadMessageCount =
    unreadMessageCount > MAX_UNREAD_MESSAGE_COUNT
      ? `${MAX_UNREAD_MESSAGE_COUNT}+`
      : unreadMessageCount;

  const badgeContent = showDisconnectedBadge ? '!' : formattedUnreadMessageCount;

  if (unreadMessageCount === 0 && !showDisconnectedBadge) return null;

  return (
    <Badge variant={VARIANTS.CRITICAL}>
      <Badge.Text size='xs' color='inverse'>
        {badgeContent}
      </Badge.Text>
    </Badge>
  );
};

export default NotificationBadge;
